import Colors from "../../../theme/colors";

const styles = {
  container: {
    backgroundColor: Colors.white,
    border: `1px solid ${Colors.lightGray}`,
    borderRadius: "8px",
  },
  customTextFieldSecondary: {
    width: "100%",
  },
};

export default styles;
